
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ups",
      function () {
        return require("private-next-pages/ups.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ups"])
      });
    }
  